export default __webpack_public_path__ + "static/media/sitemap-banner.182dba4a.jpg";